// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__g3ipA","title":"Header_title__-Q-8-","side":"Header_side__2HJVt"};